export const INTEGRATIONS_TYPES = {
  slack: 'slack',
  xero: 'xero',
  qbo: 'qbo'
};

export const TRACKING_EVENTS = {
  VIEWED_GO_PRO_MODAL: 'Viewed go-pro modal',
  CHOSE_FORECASTING_ONBOARDING: 'Chose forecasting onboarding',
  CHOSE_REPORTING_ONBOARDING: 'Chose reporting onboarding'
};

export const EXIT_SETTINGS_KEY = 'exitSettings';

export const INTERCOM_LAUNCHER_ID = 'intercomLauncher';

export const ZEN_DESK_URL = 'https://support.futrli.com/';

export const DEFAULT_PAGE_TITLE = 'Futrli';
